import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DatesService } from "src/app/shared/services/dates.service";

@Component({
  selector: 'app-modal-seleccionar-cheque',
  templateUrl: './modal-seleccionar-cheque.component.html',
  styleUrls: ['./modal-seleccionar-cheque.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionarChequeComponent implements OnInit {

  @ViewChild('seleccionarCheque', { static: true }) modalSeleccionarCheque: ModalDirective;

  // Outputs
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Form
  formData: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  cliente_proveedor_rut: number = null
  listaCheques: Array<any> = null
  busquedaIniciada: boolean = false
  paginationContext: PaginationContext = new PaginationContext()

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private depositoDocumentoService: DepositoDocumentoService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService,
  ) {
    this.log = this.clog.log('MODAL-PROTESTO-CHEQUES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10
    this.createForm()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      nroCheque: [null],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
    });
  }

  buscar(currentPage: number) {
    this.busquedaIniciada = false
    // this.formValidatorsService.validateAllFormFields(this.formData)
    // if (!this.formData.valid)
    //   return

    this.paginationContext.CurrentPage = currentPage
    const inputParams = this.createInputParams(this.formData.get('nroCheque').value)
    this.log('inputParams', JSON.stringify(inputParams))
    this.depositoDocumentoService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.busquedaIniciada = true
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaCheques = registros
      this.log(this.listaCheques)
    })
  }

  createInputParams(numero_doc) {
    return {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: this.cliente_proveedor_rut,
        estado: 2,
        numero_doc,
        numero_cuenta_cheque: '',
        fecha_desde: this.formData.get('fechaDesde').value,
        fecha_hasta: this.formData.get('fechaHasta').value
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  show(cliente_proveedor_rut) {
    this.cliente_proveedor_rut = cliente_proveedor_rut
    this.resetForm()
    this.modalSeleccionarCheque.show()
  }

  hide() {
    this.modalSeleccionarCheque.hide()
  }

  resetForm() {
    this.busquedaIniciada = false
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()
    this.listaCheques = null
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData.get("fechaDesde").setValue(initDate)
    this.formData.get("fechaHasta").setValue(currentDate)
  }

  onSeleccionarCheque(cheque) {
    this.log('onSeleccionarCheque', cheque)
    this.onSelect.emit(cheque)
    this.hide()
  }

  lastCodigo: string = ''
  // Método para ser consumido desde fuera del componente
  searchByCodigo(cliente_proveedor_rut, codigo: string) {
    this.cliente_proveedor_rut = cliente_proveedor_rut
    if (this.lastCodigo !== codigo) {
      this.lastCodigo = codigo
      // return
      this.paginationContext.CurrentPage = 1
      const inputParams = this.createInputParams(codigo)

      this.depositoDocumentoService.obtenerSegunFiltro(inputParams, ({ respuesta }) => {
        if (!respuesta)
          return
        const { registros } = respuesta
        if (registros.length === 1) {
          this.onSeleccionarCheque(registros[0])
        } else {
          this.onNotFound.emit()
        }
      })
    }
    // }, 500)
  }

  cleanLast() {
    this.lastCodigo = ''
  }

}
